<template>
	<v-dialog
		transition="dialog-top-transition"
		v-model="isOpenConfiguratorStepper"
		persistent
		max-width="1600"
		height="90%"
	>
		<v-card elevation="0">
			<v-stepper flat v-model="currentStep">
				<v-stepper-header class="elevation-0">
					<v-stepper-step :complete="currentStep > 1" step="1">
						Familia
					</v-stepper-step>

					<v-divider></v-divider>

					<v-stepper-step :complete="currentStep > 2" step="2">
						Unidad de Venta
					</v-stepper-step>

					<v-divider></v-divider>

					<v-stepper-step :complete="currentStep > 3" step="3">
						Tarifa
					</v-stepper-step>

					<v-divider></v-divider>

					<v-stepper-step step="4">
						Datos de la línea
					</v-stepper-step>
				</v-stepper-header>
				<!-- <v-divider></v-divider> -->
				<v-stepper-items>
					<v-stepper-content step="1">
						<v-card elevation="0">
							<v-item-group mandatory>
								<v-container>
									<v-row>
										<v-col
											v-for="n in categories.length"
											:key="n"
											cols="12"
											md="6"
										>
											<v-item v-slot="{ active, toggle }">
												<v-card
													:color="
														active &&
														selectedCategory
															? 'yellow darken-2'
															: 'primary darken-1'
													"
													class="d-flex align-center"
													dark
													height="200"
													hover
													width="700"
													@click="
														toggle();
														changeSelectedCategory(
															categories[n - 1]
														);
													"
													elevation="0"
												>
													<v-scroll-y-transition>
														<div
															class="
																display-3
																flex-grow-1
																text-center
																flex-row
															"
														>
															<v-icon size="70">
																{{
																	categoryIcons[
																		n - 1
																	]
																}}
															</v-icon>
															{{
																categories[
																	n - 1
																].name
															}}
														</div>
													</v-scroll-y-transition>
												</v-card>
											</v-item>
										</v-col>
									</v-row>
								</v-container>
							</v-item-group>
						</v-card>
					</v-stepper-content>

					<v-stepper-content step="2">
						<v-card elevation="0">
							<v-item-group mandatory>
								<v-container>
									<v-row>
										<v-col cols="12">
											<v-card class="mt-n4" elevation="0">
												<v-text-field
													v-model="searchSellingUnits"
													append-icon="mdi-magnify"
													label="Buscar"
													single-line
													hide-details
													class="pb-2 px-2"
												></v-text-field>
											</v-card>
										</v-col>
									</v-row>

									<v-row justify="center">
										<v-col
											align="center"
											v-for="n in availableSellTypes.length"
											:key="n"
											cols="12"
											xl="4"
											lg="4"
											md="4"
										>
											<v-item v-slot="{ active, toggle }">
												<v-card
													:color="
														active &&
														paquete.tipoVenta
															? 'yellow darken-2'
															: 'primary darken-1'
													"
													class="d-flex align-center"
													dark
													:height="
														!$vuetify.breakpoint
															.mdAndDown
															? 120
															: 85
													"
													width="500"
													@click="
														toggle();
														changeSelectedSellingUnit(
															availableSellTypes[
																n - 1
															]
														);
													"
													elevation="0"
												>
													<v-scroll-y-transition>
														<div
															class="
																text-h5
																flex-grow-1
																text-center
																flex-row
															"
														>
															{{
																availableSellTypes[
																	n - 1
																]
															}}
														</div>
													</v-scroll-y-transition>
												</v-card>
											</v-item>
										</v-col>
									</v-row>
								</v-container>
							</v-item-group>
						</v-card>
					</v-stepper-content>

					<v-stepper-content step="3" class="mt-n5 mb-n8">
						<v-card height="100%">
							<v-item-group mandatory>
								<v-container>
									<v-row>
										<v-col cols="12">
											<v-card class="mt-n4" elevation="0">
												<v-text-field
													v-model="searchTariffs"
													append-icon="mdi-magnify"
													label="Buscar"
													single-line
													hide-details
													class="pb-2 px-2"
												></v-text-field>
											</v-card>
										</v-col>
									</v-row>

									<v-row
										class="mb-3 pt-6"
										style="
											height: 450px;
											overflow-y: scroll;
										"
									>
										<v-col
											v-for="(tariff, n) in filterTariffs"
											:key="n"
											cols="12"
											md="4"
											lg="3"
										>
											<v-item v-slot="{ active, toggle }">
												<v-card
													:style="
														active && selectedTariff
															? 'border-style: solid !important;border-radius: 5px !important;border-color: #bf0000 !important;border-width: 6px !important;'
															: ''
													"
													class="d-flex align-center"
													:class="
														$vuetify.breakpoint
															.mdAndDown
															? 'ma-0 pa-3'
															: 'pa-0'
													"
													:color="
														active
															? 'black'
															: tariff.color
															? tariff.color
															: tariffColors[n]
													"
													dark
													:height="
														!$vuetify.breakpoint
															.mdAndDown
															? 160
															: 85
													"
													@click="
														toggle();
														changeSelectedTariff(
															tariff
														);
													"
													elevation="0"
												>
													<v-btn
														fab
														color="red"
														top
														absolute
														right
														v-if="
															activeAdditionals &&
															n <
																activeAdditionals
														"
														large
													>
														<div
															class="
																d-flex
																justify-center
																flex-column
															"
														>
															<v-icon
																class="ml-4"
																size="27"
																>mdi-toy-brick-plus-outline</v-icon
															>
															<small
																class="
																	overline
																	my-n2
																"
																><small
																	><small
																		v-if="
																			mainLineIsEmpty
																		"
																		>Adicional</small
																	><small
																		v-else
																		>Compatible</small
																	></small
																></small
															>
														</div>
													</v-btn>
													<v-scroll-y-transition>
														<div
															class="
																display-1
																font-weight-light
																flex-grow-1
																text-center
																flex-row
															"
															:style="
																$vuetify
																	.breakpoint
																	.mdAndDown
																	? 'font-size: 1.5rem !important;'
																	: ''
															"
														>
															{{ tariff.name }}
														</div>
													</v-scroll-y-transition>
												</v-card>
											</v-item>
											<!-- </v-badge> -->
										</v-col>
									</v-row>

									<v-row
										class="mt-md-4"
										v-if="selectedTariff"
									>
										<v-col
											v-if="
												!$vuetify.breakpoint.smAndDown
											"
											cols="12"
											md="4"
										>
											<v-alert
												height="90%"
												color="primary"
												dark
												outlined
												class="pl-6 d-flex align-center"
												icon="mdi-book-open-outline"
												border="left"
												prominent
											>
												<a
													v-if="
														selectedTariff.description_file
													"
													:href="
														selectedTariff.description_file
													"
													target="_blank"
													class="
														pt-5
														font-weight-regular
														primary--text
														text-h5
													"
													style="
														text-decoration: none;
													"
												>
													Archivo de Descripción
													Detallada
												</a>
												<p
													class="
														pt-5
														font-weight-regular
														primary--text
														text-h5
													"
													style="
														text-decoration: none;
													"
													v-else
												>
													Sin Archivo de Descripción
												</p>
											</v-alert>
										</v-col>

										<v-col
											cols="12"
											md="4"
											v-if="
												selectedTariff &&
												!$vuetify.breakpoint.smAndDown
											"
										>
											<v-alert
												height="90%"
												color="primary"
												class="pl-6 d-flex align-center"
												dark
												icon="mdi-sale"
												outlined
												border="left"
												prominent
											>
												<h2
													class="
														font-weight-regular
														primary--text
													"
												>
													Descuentos Aplicables
												</h2>
												<h4
													v-if="
														selectedTariff
															.promotions
															.length == 0
													"
													class="
														font-weight-regular
														primary--text
													"
												>
													Sin descuentos
												</h4>
												<h2
													v-else
													class="
														font-weight-light
														primary--text
													"
												>
													{{
														availablePromotions.length
													}}
												</h2>
											</v-alert>
										</v-col>

										<v-col
											cols="12"
											md="4"
											v-if="selectedTariff"
										>
											<v-alert
												height="90%"
												color="primary"
												class="pl-6 d-flex align-center"
												dark
												icon="mdi-cash"
												outlined
												border="left"
												prominent
											>
												<h2
													class="
														font-weight-regular
														primary--text
													"
												>
													PVP
												</h2>
												<h2
													class="
														font-weight-light
														primary--text
													"
												>
													{{
														parseFloat(
															(
																selectedTariff.price *
																iva
															).toFixed(2)
														).toLocaleString() + '€'
													}}
												</h2>
											</v-alert>
										</v-col>
									</v-row>
								</v-container>
							</v-item-group>
						</v-card>
					</v-stepper-content>

					<v-stepper-content step="4">
						<!--Desktop view-->
						<v-card v-if="!$vuetify.breakpoint.smAndDown">
							<v-row>
								<v-col md="12">
									<v-card>
										<v-row class="mx-md-2">
											<v-col
												md="4"
												class="mb-md-1 mt-md-1"
											>
												<h4
													class="
														font-weight-light
														primary--text
													"
												>
													Números que llevarán esta
													tarifa asociada
												</h4>
											</v-col>
											<v-col
												md="8"
												class="mb-md-1 mt-md-1 pl-md-6"
											>
												<h4
													class="
														font-weight-light
														primary--text
													"
												>
													Promociones aplicables a la
													tarifa seleccionada
												</h4>
											</v-col>
										</v-row>
										<v-divider style="display: none" class="mx-md-4"></v-divider>
										<v-row class="topFixedHeigth mx-2">
											<v-col
												cols="4"
												class="d-flex align-center"
											>
												<v-container>
													<v-combobox
														v-model="
															selectedPhoneNumbers
														"
														:class="
															selectedPromotionId
																? 'pt-md-5'
																: ''
														"
														:items="
															availableTelefonosContacto
														"
														:search-input.sync="
															searchPhoneNumber
														"
														@change="
															stepperPhoneNumberChanged
														"
														label="Introduzca Número(s) Asociados"
														multiple
														:error-messages="
															phoneNumberErrorMessages
														"
														prepend-icon="mdi-phone-log-outline"
														clearable
													>
														<template
															#selection="{
																item,
															}"
														>
															<v-chip
																color="yellow darken-3"
																outlined
																class="
																	white--text
																"
															>
																<v-icon>
																	mdi-phone
																</v-icon>
																{{ item }}
															</v-chip>
														</template>
													</v-combobox>
												</v-container>
											</v-col>

											<v-col
												cols="8"
												class="d-flex align-center px-2"
											>
												<v-select
													v-model="selectedPromotion"
													:class="
														selectedPhoneNumbers.length >
															0 &&
														selectedPromotion.length ==
															0
															? 'pt-md-5'
															: ''
													"
													:items="availablePromotions"
													:item-text="
														selectedPromotion &&
														selectedPromotion.name
															? 'name'
															: 'id'
													"
													item-value="id"
													label="Promociones Aplicables"
													prepend-icon="mdi-sale"
													small
													multiple
													clearable
												>
													<template
														v-slot:item="{ item }"
													>
														<v-row>
															<v-col cols="11">
																{{
																	item.name
																		? item.name
																		: item.id
																}}
															</v-col>
															<v-col cols="1">
																<v-btn
																	v-if="
																		selectedPromotion.indexOf(
																			item
																		) != -1
																	"
																	x-small
																	dark
																	depressed
																	color="red darken-2"
																	fab
																	>{{
																		selectedPromotion.indexOf(
																			item
																		) + 1
																	}}</v-btn
																>
															</v-col>
														</v-row>
													</template>
													<template
														#selection="{ item }"
													>
														<v-chip
															color="yellow darken-3"
															outlined
															v-if="
																selectedPromotion.indexOf(
																	item
																) != -1
															"
															class="white--text"
														>
															<v-row>
																<v-col
																	cols="10"
																>
																	<v-icon>
																		mdi-sale
																	</v-icon>
																	{{
																		item.name
																			? item.name
																			: item.id
																	}}
																</v-col>
																<v-col
																	cols="2"
																	class="
																		d-flex
																		justify-center
																	"
																>
																	<v-icon
																		left
																	>
																		{{
																			'mdi-numeric-' +
																			(selectedPromotion.indexOf(
																				item
																			) +
																				1) +
																			'-box'
																		}}
																	</v-icon>
																</v-col>
															</v-row>
														</v-chip>
													</template>
												</v-select>
											</v-col>
										</v-row>
									</v-card>
								</v-col>
							</v-row>

							<v-row
								v-if="ckeckGroupPermission([GROUPS.MASMOVIL])"
								class="mt-md-n4"
							>
								<v-col cols="12">
									<v-card elevation="0">
										<v-row class="mx-md-4">
											<v-col md="4" class="mb-my-1">
												<h4
													class="
														font-weight-light
														primary--text
													"
												>
													Dispositivo
												</h4>
											</v-col>
											<v-col
												md="4"
												class="
													d-flex
													justify-start
													mb-my-1
												"
											>
												<h4
													v-if="createInstallment"
													class="
														font-weight-light
														primary--text
													"
												>
													Precio por Tarifa
												</h4>
											</v-col>
											<v-col md="2" class="mb-my-1">
												<h4
													class="
														font-weight-light
														primary--text
													"
												>
													Seguro del dispositivo
												</h4>
											</v-col>
											<v-col
												md="2"
												class="mb-my-1 pl-md-12"
											>
												<h4
													class="
														font-weight-light
														primary--text
													"
												>
													¿Es Cross?
												</h4>
											</v-col>
										</v-row>
										<v-divider style="display: none" class="mx-md-6"></v-divider>
										<v-row
											class="fixedHeigth py-4"
											style="width: 100%"
											no-gutters
										>
											<v-col class="px-4" md="8">
												<v-row>
													<v-col md="6">
														<v-container fluid>
															<v-autocomplete
																:disabled="
																	terminals.length <=
																	0
																"
																v-model="
																	selectedTerminal
																"
																:items="
																	terminals
																"
																item-text="name"
																hide-selected
																label="Seleccione un Dispositivo"
																:menu-props="{
																	maxHeight: 300,
																}"
																return-object
																prepend-icon="mdi-cellphone"
																persistent-hint
																clearable
															>
																<template
																	#selection="{
																		item,
																	}"
																>
																	<v-chip
																		color="yellow darken-3"
																		class="
																			white--text
																		"
																		outlined
																	>
																		<v-icon>
																			mdi-cellphone
																		</v-icon>
																		{{
																			item.name
																		}}
																	</v-chip>
																</template>
																<template
																	v-slot:label="{
																		item,
																	}"
																>
																	{{
																		item.name
																	}}
																</template>
															</v-autocomplete>
														</v-container>
													</v-col>
													<v-col
														md="6"
														class="
															d-flex
															justify-center
														"
													>
														<v-row no-gutters>
															<v-col
																:md="
																	createInstallment
																		? '7'
																		: '12'
																"
																class="
																	d-flex
																	justify-center
																	align-self-center
																"
															>
																<v-select
																	:disabled="
																		!selectedTerminal ||
																		filterInstallments()
																			.length <
																			1
																	"
																	placeholder="Selección de precio por tarifa"
																	class="pt-4"
																	:error-messages="
																		!selectedTerminal
																			? 'Seleccione un terminal primero'
																			: ''
																	"
																	:items="
																		filterInstallments()
																	"
																	v-model="
																		paquete.installment
																	"
																	item-value="id"
																	return-object
																	clearable
																>
																	<template
																		v-slot:selection="{
																			item,
																		}"
																	>
																		<div
																			class="
																				my-n2
																			"
																		>
																			<v-row
																				no-gutters
																			>
																				<v-col
																					cols="4"
																					class="
																						d-flex
																						justify-center
																						px-3
																					"
																					><small
																						class="
																							font-weight-light
																							primary--text
																						"
																						>Inicial</small
																					></v-col
																				>
																				<v-col
																					cols="4"
																					class="
																						d-flex
																						justify-center
																						px-3
																					"
																					><small
																						class="
																							font-weight-light
																							primary--text
																						"
																						>Mensual</small
																					></v-col
																				>
																				<v-col
																					cols="4"
																					class="
																						d-flex
																						justify-center
																						px-3
																					"
																					><small
																						class="
																							font-weight-light
																							primary--text
																						"
																						>Final</small
																					></v-col
																				>
																			</v-row>

																			<v-row
																				no-gutters
																			>
																				<v-col
																					cols="4"
																					class="
																						d-flex
																						justify-center
																						px-3
																					"
																					><p>
																						{{
																							item.initial_price
																								? item.initial_price +
																								  '€'
																								: '---'
																						}}
																					</p></v-col
																				>
																				<v-col
																					cols="4"
																					class="
																						d-flex
																						justify-center
																						px-3
																					"
																					><p>
																						{{
																							item.month_price
																								? item.month_price +
																								  '€'
																								: '---'
																						}}
																					</p></v-col
																				>
																				<v-col
																					cols="4"
																					class="
																						d-flex
																						justify-center
																						px-3
																					"
																					><p>
																						{{
																							item.final_price
																								? item.final_price +
																								  '€'
																								: '---'
																						}}
																					</p></v-col
																				>
																			</v-row>
																		</div>
																	</template>
																	<template
																		v-slot:item="{
																			item,
																		}"
																	>
																		<div
																			class="
																				my-n0
																			"
																		>
																			<v-row
																				no-gutters
																			>
																				<v-col
																					cols="4"
																					class="
																						d-flex
																						justify-center
																						px-3
																					"
																					><small
																						class="
																							font-weight-light
																							primary--text
																						"
																						>Inicial</small
																					></v-col
																				>
																				<v-col
																					cols="4"
																					class="
																						d-flex
																						justify-center
																						px-3
																					"
																					><small
																						class="
																							font-weight-light
																							primary--text
																						"
																						>Mensual</small
																					></v-col
																				>
																				<v-col
																					cols="4"
																					class="
																						d-flex
																						justify-center
																						px-3
																					"
																					><small
																						class="
																							font-weight-light
																							primary--text
																						"
																						>Final</small
																					></v-col
																				>
																			</v-row>

																			<v-row
																				no-gutters
																			>
																				<v-col
																					cols="4"
																					class="
																						d-flex
																						justify-center
																						px-3
																					"
																					><p>
																						{{
																							item.initial_price
																								? item.initial_price +
																								  '€'
																								: '---'
																						}}
																					</p></v-col
																				>
																				<v-col
																					cols="4"
																					class="
																						d-flex
																						justify-center
																						px-3
																					"
																					><p>
																						{{
																							item.month_price
																								? item.month_price +
																								  '€'
																								: '---'
																						}}
																					</p></v-col
																				>
																				<v-col
																					cols="4"
																					class="
																						d-flex
																						justify-center
																						px-3
																					"
																					><p>
																						{{
																							item.final_price
																								? item.final_price +
																								  '€'
																								: '---'
																						}}
																					</p></v-col
																				>
																			</v-row>
																		</div>
																	</template>
																</v-select>
															</v-col>
															<v-col
																v-if="
																	createInstallment
																"
																cols="5"
																class="
																	d-flex
																	justify-center
																	align-self-center
																"
															>
																<v-tooltip top>
																	<template
																		v-slot:activator="{
																			on,
																			attrs,
																		}"
																	>
																		<v-btn
																			:disabled="
																				!selectedTerminal
																			"
																			small
																			outlined
																			color="yellow darken-3"
																			@click="
																				openAddingForm()
																			"
																			v-bind="
																				attrs
																			"
																			v-on="
																				on
																			"
																		>
																			Personalizado
																			<v-icon
																				right
																				>mdi-plus</v-icon
																			>
																		</v-btn>
																	</template>
																	<v-row
																		class="
																			pa-2
																		"
																		style="
																			width: 290px !important;
																		"
																	>
																		<v-col
																			class="
																				text-justify
																			"
																			cols="8"
																		>
																			Antes
																			de
																			crear
																			un
																			nuevo
																			precio
																			por
																			tarifa
																			recuerde
																			comprobar
																			que
																			no
																			exista.
																		</v-col>
																		<v-col
																			cols="4"
																			class="
																				d-flex
																				justify-center
																				px-6
																				align-self-center
																			"
																		>
																			<v-icon
																				size="60"
																				color="yellow darken-3"
																			>
																				mdi-alert
																			</v-icon>
																		</v-col>
																	</v-row>
																</v-tooltip>
															</v-col>
														</v-row>
													</v-col>
												</v-row>
											</v-col>

											<v-col class="px-2" cols="2">
												<v-row>
													<v-col
														md="7"
														class="pt-md-9"
													>
														<v-switch
															class=""
															v-model="
																hasInsurance
															"
															:disabled="
																!selectedTerminal ||
																!selectedTerminal.seguro
															"
															label="Seguro"
															color="primary"
															hide-details
															prepend-icon="mdi-shield-plus-outline"
														>
														</v-switch>
													</v-col>
													<v-col md="5" class="mt-6">
														<v-btn
															fab
															small
															large
															outlined
															color="yellow darken-3"
														>
															{{
																selectedTerminal
																	? selectedTerminal.seguro
																		? parseFloat(
																				(
																					selectedTerminal
																						.seguro
																						.price *
																					iva
																				).toFixed(
																					2
																				)
																		  ).toLocaleString() +
																		  '€'
																		: 'N/A'
																	: 'N/A'
															}}
														</v-btn>
													</v-col>
												</v-row>
											</v-col>

											<v-col
												class="pl-12 align-self-center"
												md="2"
											>
												<v-switch
													v-model="paquete.crossSell"
													label="Cross"
													:disabled="
														paquete.tipoVenta ==
															'MIGRACION' ||
														(selectedTariff &&
															selectedTariff.category !=
																'convergent')
													"
													color="primary"
													hide-details
													prepend-icon="mdi-arrow-decision-outline"
												>
												</v-switch>
											</v-col>
										</v-row>
									</v-card>
								</v-col>
							</v-row>

							<v-row no-gutters class="mt-md-2">
								<v-col cols="12">
									<v-alert>
										<v-row>
											<v-col cols="12">
												<h1
													class="
														font-weight-regular
													"
												>
													Resumen
												</h1>
											</v-col>
										</v-row>
										<v-divider
											class="mt-2 mb-4"
										></v-divider>
										<v-row>
											<v-col cols="3">
												<h3
													class="
														font-weight-regular
													"
												>
													Números Asociados
												</h3>
												<div class="d-flex flex-row">
													<h4
														class="
															py-5
															font-weight-light
														"
														:class="
															selectedPhoneNumbers.length !=
															0
																? 'black--text'
																: 'red--text'
														"
													>
														{{
															selectedPhoneNumbers.length !=
															0
																? selectedPhoneNumbers
																		.toString()
																		.replaceAll(
																			',',
																			', '
																		)
																: 'Sin linea asociada'
														}}
													</h4>
												</div>
											</v-col>
											<v-col cols="3">
												<h3
													class="
														font-weight-regular
													"
												>
													Tarifa
												</h3>
												<h4
													class="
														py-5
														font-weight-light
													"
												>
													{{
														selectedTariff
															? selectedTariff.name
															: ''
													}}
												</h4>
											</v-col>
											<v-col cols="3">
												<h3
													class="
														font-weight-regular
													"
												>
													Terminal
												</h3>
												<h4
													class="
														pt-5
														font-weight-light
													"
												>
													{{
														selectedTerminal
															? selectedTerminal.name
															: ''
													}}
												</h4>
											</v-col>
											<v-col cols="1">
												<h3
													class="
														font-weight-regular
														text-center
													"
												>
													Seguro
												</h3>
												<div
													class="
														d-flex
														justify-center
													"
													v-if="hasInsurance"
												>
													<v-icon
														size="30"
														class="pt-3"
														color="green darken-2"
													>
														mdi-check-circle-outline
													</v-icon>
												</div>

												<div
													v-else
													class="
														d-flex
														justify-center
													"
												>
													<v-icon
														size="30"
														class="pt-3"
														color="red darken-3"
													>
														mdi-close-circle-outline
													</v-icon>
												</div>
											</v-col>
											<v-divider vertical></v-divider>
											<v-col cols="2">
												<h2
													class="
														mt-n1
														font-weight-regular
														text-center
													"
												>
													Precio
												</h2>
												<h2
													class="
														mt-2
														font-weight-regular
														text-center
													"
												>
													{{
														selectedTariff
															? parseFloat(
																	(
																		selectedTariff.price *
																			iva +
																		(selectedTerminal &&
																		selectedTerminal.seguro &&
																		hasInsurance &&
																		arrayDescuentosAplicados.length ==
																			0
																			? selectedTerminal
																					.seguro
																					.price *
																			  iva
																			: 0)
																	).toFixed(2)
															  ).toLocaleString() +
															  '€'
															: ''
													}}
												</h2>
											</v-col>
										</v-row>

										<!-- Cabecera de las promociones -->
										<v-row
											v-if="selectedPromotion.length != 0"
										>
											<v-col cols="3"> </v-col>
											<v-col cols="3">
												<h3 class="font-weight-regular">
													Promociones
												</h3>
											</v-col>
											<v-col cols="3">
												<h3 class="font-weight-regular">
													Duración
												</h3>
											</v-col>
											<v-col cols="1">
												<h3
													class="
														font-weight-regular
														text-center
													"
												>
													Descuento
												</h3>
											</v-col>
											<v-divider vertical></v-divider>
											<v-col cols="2"></v-col>
										</v-row>
										<v-row
											v-for="(
												promotion, index
											) in selectedPromotion"
											:key="index"
										>
											<v-col cols="3"> </v-col>
											<v-col
												cols="3"
												class="d-flex align-center"
											>
												<v-tooltip
													left
													v-if="
														promotion.observations
													"
												>
													<template
														v-slot:activator="{
															on,
															attrs,
														}"
													>
														<v-btn
															icon
															color="primary"
															dark
															v-bind="attrs"
															v-on="on"
														>
															<v-icon
																color="primary"
															>
																mdi-magnify
															</v-icon>
														</v-btn>
													</template>
													<span>{{
														promotion.observations
													}}</span>
												</v-tooltip>
												<h4
													class="
														font-weight-light
													"
												>
													{{ promotion.name }}
												</h4>
											</v-col>
											<v-col cols="3">
												<h4
													class="
														font-weight-light
													"
												>
													{{
														promotion.duration
															? `${promotion.duration} Meses`
															: 'Para siempre'
													}}
												</h4>
											</v-col>
											<v-col cols="1">
												<h4
													class="
														font-weight-light
														text-center
													"
												>
													{{
														selectedTariff
															? `${parseFloat(
																	promotion.amount *
																		(selectedTariff.segment ==
																			'NEGOCIOS' &&
																		promotion.amount_unit ==
																			'MONETARY'
																			? iva
																			: 1)
															  )} ${
																	promotion.amount_unit ==
																	'MONETARY'
																		? '€'
																		: '%'
															  }`
															: ''
													}}
												</h4>
											</v-col>
											<v-divider vertical></v-divider>
											<v-col cols="2">
												<h4
													class="
														font-weight-regular
														black--text
														text-center
													"
												>
													{{
														arrayDescuentosAplicados.length !=
														0
															? parseFloat(
																	arrayDescuentosAplicados[
																		index
																	].toFixed(2)
															  ).toLocaleString() +
															  '€'
															: ''
													}}
												</h4>
											</v-col>
										</v-row>
									</v-alert>
								</v-col>
							</v-row>
						</v-card>
						<!--Mobile view-->
						<v-card v-if="$vuetify.breakpoint.smAndDown">
							<v-row>
								<v-col md="12">
									<v-card>
										<v-row class="pa-3 aling-center">
											<v-col
												cols="12"
												class="d-flex justify-center"
											>
												<h4
													class="
														font-weight
														primary--text
														text-center
													"
												>
													Números que llevarán esta
													tarifa asociada
												</h4>
											</v-col>

											<v-col
												cols="12"
												class="
													d-flex
													pa-0
													justify-center
												"
											>
												<v-container>
													<v-combobox
														v-model="
															selectedPhoneNumbers
														"
														:class="
															selectedPromotionId
																? 'pt-md-5'
																: ''
														"
														:items="
															availableTelefonosContacto
														"
														:search-input.sync="
															searchPhoneNumber
														"
														@change="
															stepperPhoneNumberChanged
														"
														label="Introduzca Número(s) Asociados"
														multiple
														:error-messages="
															phoneNumberErrorMessages
														"
														prepend-icon="mdi-phone-log-outline"
														clearable
													>
														<template
															#selection="{
																item,
															}"
														>
															<v-chip
																color="yellow darken-3"
																outlined
																class="
																	white--text
																"
															>
																<v-icon small>
																	mdi-phone
																</v-icon>
																{{ item }}
															</v-chip>
														</template>
													</v-combobox>
												</v-container>
											</v-col>
										</v-row>
										<v-divider
											class="mt-2 mb-4"
										></v-divider>
										<v-row class="pa-3 aling-center">
											<v-col
												cols="12"
												class="d-flex justify-center"
											>
												<h4
													class="
														font-weight
														primary--text
														text-center
													"
												>
													Promociones aplicables a la
													tarifa seleccionada
												</h4>
											</v-col>

											<v-col
												cols="12"
												class="d-flex justify-center"
											>
												<v-select
													v-model="selectedPromotion"
													:class="
														selectedPhoneNumbers.length >
															0 &&
														selectedPromotion.length ==
															0
															? 'pt-md-10'
															: ''
													"
													:items="availablePromotions"
													:item-text="
														selectedPromotion &&
														selectedPromotion.name
															? 'name'
															: 'id'
													"
													item-value="id"
													label="Promociones Aplicables"
													prepend-icon="mdi-sale"
													small
													multiple
													clearable
												>
													<template
														v-slot:item="{ item }"
													>
														<v-row>
															<v-col cols="10">
																{{
																	item.name
																		? item.name
																		: item.id
																}}
															</v-col>
															<v-col cols="2">
																<v-btn
																	v-if="
																		selectedPromotion.indexOf(
																			item
																		) != -1
																	"
																	x-small
																	dark
																	depressed
																	color="red darken-2"
																	fab
																	>{{
																		selectedPromotion.indexOf(
																			item
																		) + 1
																	}}</v-btn
																>
															</v-col>
														</v-row>
													</template>
													<template
														#selection="{ item }"
													>
														<v-chip
															color="yellow darken-3"
															outlined
															v-if="
																selectedPromotion.indexOf(
																	item
																) != -1
															"
															class="white--text"
														>
															<v-row>
																<v-col
																	cols="10"
																>
																	<v-icon>
																		mdi-sale
																	</v-icon>
																	{{
																		item.name
																			? item.name
																			: item.id
																	}}
																</v-col>
																<v-col
																	cols="2"
																	class="
																		d-flex
																		justify-center
																	"
																>
																	<v-icon
																		left
																	>
																		{{
																			'mdi-numeric-' +
																			(selectedPromotion.indexOf(
																				item
																			) +
																				1) +
																			'-box'
																		}}
																	</v-icon>
																</v-col>
															</v-row>
														</v-chip>
													</template>
												</v-select>
											</v-col>
										</v-row>
									</v-card>
								</v-col>
							</v-row>

							<v-row
								v-if="ckeckGroupPermission([GROUPS.MASMOVIL])"
								class="mt-md-n4"
							>
								<v-col cols="12">
									<v-card>
										<v-row class="mx-md-4">
											<v-col
												cols="12"
												class="
													d-flex
													pa-6
													justify-center
												"
											>
												<h4
													class="
														font-weight
														primary--text
													"
												>
													Dispositivo
												</h4>
											</v-col>

											<v-col class="px-4" cols="12">
												<v-row>
													<v-col
														cols="12"
														class="pa-1 d-flex"
													>
														<v-container fluid>
															<v-autocomplete
																:disabled="
																	terminals.length <=
																	0
																"
																v-model="
																	selectedTerminal
																"
																:items="
																	terminals
																"
																item-text="name"
																hide-selected
																label="Seleccione un Dispositivo"
																:menu-props="{
																	maxHeight: 300,
																}"
																return-object
																prepend-icon="mdi-cellphone"
																persistent-hint
																clearable
															>
																<template
																	#selection="{
																		item,
																	}"
																>
																	<v-chip
																		color="yellow darken-3"
																		class="
																			white--text
																		"
																		outlined
																	>
																		<v-icon>
																			mdi-cellphone
																		</v-icon>
																		{{
																			item.name
																		}}
																	</v-chip>
																</template>
																<template
																	v-slot:label="{
																		item,
																	}"
																>
																	{{
																		item.name
																	}}
																</template>
															</v-autocomplete>
														</v-container>
													</v-col>

													<v-col
														cols="12"
														class="
															d-flex
															justify-center
														"
													>
														<v-row no-gutters>
															<v-col
																cols="12"
																class="
																	px-6
																	pa-0
																	d-flex
																	justify-center
																"
															>
																<v-select
																	:disabled="
																		!selectedTerminal ||
																		filterInstallments()
																			.length <
																			1
																	"
																	placeholder="Selección de precio por tarifa"
																	class="pt-0"
																	:error-messages="
																		!selectedTerminal
																			? 'Seleccione un terminal primero'
																			: ''
																	"
																	:items="
																		filterInstallments()
																	"
																	v-model="
																		paquete.installment
																	"
																	item-value="id"
																	return-object
																	clearable
																>
																	<template
																		v-slot:selection="{
																			item,
																		}"
																	>
																		<div
																			class="
																				my-n2
																			"
																		>
																			<v-row
																				no-gutters
																			>
																				<v-col
																					cols="4"
																					class="
																						d-flex
																						justify-center
																						px-3
																					"
																					><small
																						class="
																							font-weight-light
																							primary--text
																						"
																						>Inicial</small
																					></v-col
																				>
																				<v-col
																					cols="4"
																					class="
																						d-flex
																						justify-center
																						px-3
																					"
																					><small
																						class="
																							font-weight-light
																							primary--text
																						"
																						>Mensual</small
																					></v-col
																				>
																				<v-col
																					cols="4"
																					class="
																						d-flex
																						justify-center
																						px-3
																					"
																					><small
																						class="
																							font-weight-light
																							primary--text
																						"
																						>Final</small
																					></v-col
																				>
																			</v-row>

																			<v-row
																				no-gutters
																			>
																				<v-col
																					cols="4"
																					class="
																						d-flex
																						justify-center
																						px-3
																					"
																					><p>
																						{{
																							item.initial_price
																								? item.initial_price +
																								  '€'
																								: '---'
																						}}
																					</p></v-col
																				>
																				<v-col
																					cols="4"
																					class="
																						d-flex
																						justify-center
																						px-3
																					"
																					><p>
																						{{
																							item.month_price
																								? item.month_price +
																								  '€'
																								: '---'
																						}}
																					</p></v-col
																				>
																				<v-col
																					cols="4"
																					class="
																						d-flex
																						justify-center
																						px-3
																					"
																					><p>
																						{{
																							item.final_price
																								? item.final_price +
																								  '€'
																								: '---'
																						}}
																					</p></v-col
																				>
																			</v-row>
																		</div>
																	</template>
																	<template
																		v-slot:item="{
																			item,
																		}"
																	>
																		<div
																			class="
																				my-n0
																			"
																		>
																			<v-row
																				no-gutters
																			>
																				<v-col
																					cols="4"
																					class="
																						d-flex
																						justify-center
																						px-3
																					"
																					><small
																						class="
																							font-weight-light
																							primary--text
																						"
																						>Inicial</small
																					></v-col
																				>
																				<v-col
																					cols="4"
																					class="
																						d-flex
																						justify-center
																						px-3
																					"
																					><small
																						class="
																							font-weight-light
																							primary--text
																						"
																						>Mensual</small
																					></v-col
																				>
																				<v-col
																					cols="4"
																					class="
																						d-flex
																						justify-center
																						px-3
																					"
																					><small
																						class="
																							font-weight-light
																							primary--text
																						"
																						>Final</small
																					></v-col
																				>
																			</v-row>

																			<v-row
																				no-gutters
																			>
																				<v-col
																					cols="4"
																					class="
																						d-flex
																						justify-center
																						px-3
																					"
																					><p>
																						{{
																							item.initial_price
																								? item.initial_price +
																								  '€'
																								: '---'
																						}}
																					</p></v-col
																				>
																				<v-col
																					cols="4"
																					class="
																						d-flex
																						justify-center
																						px-3
																					"
																					><p>
																						{{
																							item.month_price
																								? item.month_price +
																								  '€'
																								: '---'
																						}}
																					</p></v-col
																				>
																				<v-col
																					cols="4"
																					class="
																						d-flex
																						justify-center
																						px-3
																					"
																					><p>
																						{{
																							item.final_price
																								? item.final_price +
																								  '€'
																								: '---'
																						}}
																					</p></v-col
																				>
																			</v-row>
																		</div>
																	</template>
																</v-select>
															</v-col>
															<v-col
																v-if="
																	createInstallment
																"
																cols="5"
																class="
																	d-flex
																	justify-center
																	align-self-center
																"
															>
																<v-tooltip top>
																	<template
																		v-slot:activator="{
																			on,
																			attrs,
																		}"
																	>
																		<v-btn
																			:disabled="
																				!selectedTerminal
																			"
																			small
																			outlined
																			color="yellow darken-3"
																			@click="
																				openAddingForm()
																			"
																			v-bind="
																				attrs
																			"
																			v-on="
																				on
																			"
																		>
																			Personalizado
																			<v-icon
																				right
																				>mdi-plus</v-icon
																			>
																		</v-btn>
																	</template>
																	<v-row
																		class="
																			pa-2
																		"
																		style="
																			width: 290px !important;
																		"
																	>
																		<v-col
																			class="
																				text-justify
																			"
																			cols="8"
																		>
																			Antes
																			de
																			crear
																			un
																			nuevo
																			precio
																			por
																			tarifa
																			recuerde
																			comprobar
																			que
																			no
																			exista.
																		</v-col>
																		<v-col
																			cols="4"
																			class="
																				d-flex
																				justify-center
																				px-6
																				align-self-center
																			"
																		>
																			<v-icon
																				size="60"
																				color="yellow darken-3"
																			>
																				mdi-alert
																			</v-icon>
																		</v-col>
																	</v-row>
																</v-tooltip>
															</v-col>
														</v-row>
													</v-col>
												</v-row>
											</v-col>
											<!-- <v-col
                                                md="4"
                                                class="
                                                    d-flex
                                                    justify-start
                                                    mb-my-1
                                                "
                                            >
                                                <h4
                                                    v-if="createInstallment"
                                                    class="
                                                        font-weight-light
                                                        primary--text
                                                    "
                                                >
                                                    Precio por Tarifa
                                                </h4>
                                            </v-col>
                                             -->
										</v-row>
										<v-divider style="display: none" class="mx-md-6"></v-divider>
										<v-row
											class="fixedHeigth py-4"
											style="width: 100%"
											no-gutters
										>
											<v-col
												cols="12"
												class="
													d-flex
													pa-3
													justify-center
												"
											>
												<h4
													class="
														font-weight
														primary--text
													"
												>
													Seguro del dispositivo
												</h4>
											</v-col>

											<v-col cols="12" class="d-flex">
												<v-row>
													<v-col
														cols="8"
														class="
															pt-md-8
															pa-10
															d-flex
														"
													>
														<v-switch
															class=""
															v-model="
																hasInsurance
															"
															:disabled="
																!selectedTerminal ||
																!selectedTerminal.seguro
															"
															label="Seguro"
															color="primary"
															hide-details
															prepend-icon="mdi-shield-plus-outline"
														>
														</v-switch>
													</v-col>
													<v-col
														cols="4"
														class="mt-6 d-flex"
													>
														<v-btn
															fab
															small
															large
															outlined
															color="yellow darken-3"
														>
															{{
																selectedTerminal
																	? selectedTerminal.seguro
																		? parseFloat(
																				(
																					selectedTerminal
																						.seguro
																						.price *
																					iva
																				).toFixed(
																					2
																				)
																		  ).toLocaleString() +
																		  '€'
																		: 'N/A'
																	: 'N/A'
															}}
														</v-btn>
													</v-col>
												</v-row>
											</v-col>
										</v-row>

										<v-row
											class="fixedHeigth py-4"
											style="width: 100%"
											no-gutters
										>
											<v-col
												cols="12"
												class="
													d-flex
													justify-center
													pa-3
												"
											>
												<h4
													class="
														font-weight
														primary--text
													"
												>
													¿Es Cross?
												</h4>
											</v-col>
											<v-col
												class="
													d-flex
													justify-center
													pa-0
												"
												cols="12"
											>
												<v-switch
													v-model="paquete.crossSell"
													label="Cross"
													:disabled="
														paquete.tipoVenta ==
															'MIGRACION' ||
														(selectedTariff &&
															selectedTariff.category !=
																'convergent')
													"
													color="primary"
													hide-details
													prepend-icon="mdi-arrow-decision-outline"
												>
												</v-switch>
											</v-col>
										</v-row>
									</v-card>
								</v-col>
							</v-row>

							<!--CARD RESUMEN-->
							<v-row no-gutters class="mt-md-2">
								<v-col cols="12">
									<v-alert>
										<v-row>
											<v-col
												cols="12"
												class="d-flex-justify-center"
											>
												<h1
													class="
														font-weight-regular
													"
												>
													Resumen
												</h1>
											</v-col>
										</v-row>
										<v-divider
											class="mt-2 mb-4"
										></v-divider>
										<v-row>
											<v-col
												:cols="
													$vuetify.breakpoint
														.smAndDown
														? '12'
														: '3'
												"
											>
												<h3
													class="
														font-weight-regular
														text-center
													"
												>
													Números Asociados
												</h3>
												<div class="justify-center">
													<h4
														class="
															py-5
															font-weight-light
															text-center
														"
														:class="
															selectedPhoneNumbers.length !=
															0
																? 'black--text'
																: 'red--text'
														"
													>
														{{
															selectedPhoneNumbers.length !=
															0
																? selectedPhoneNumbers
																		.toString()
																		.replaceAll(
																			',',
																			', '
																		)
																: 'Sin linea asociada'
														}}
													</h4>
												</div>
											</v-col>
											<v-col
												:cols="
													$vuetify.breakpoint
														.smAndDown
														? '6'
														: '3'
												"
											>
												<h3
													class="
														font-weight-regular
														text-center
													"
												>
													Tarifa
												</h3>
												<h4
													class="
														py-5
														font-weight-light
														text-center
													"
												>
													{{
														selectedTariff
															? selectedTariff.name
															: ''
													}}
												</h4>
											</v-col>
											<v-col
												:cols="
													$vuetify.breakpoint
														.smAndDown
														? '6'
														: '3'
												"
											>
												<h3
													class="
														font-weight-regular
													"
												>
													Terminal
												</h3>
												<h4
													class="
														pt-5
														font-weight-light
													"
												>
													{{
														selectedTerminal
															? selectedTerminal.name
															: ''
													}}
												</h4>
											</v-col>
											<v-col lg="1" xl="1" cols="6">
												<h3
													class="
														font-weight-regular
														text-center
													"
												>
													Seguro
												</h3>
												<div
													class="
														d-flex
														justify-center
													"
													v-if="hasInsurance"
												>
													<v-icon
														size="30"
														class="pt-3"
														color="green darken-2"
													>
														mdi-check-circle-outline
													</v-icon>
												</div>

												<div
													v-else
													class="
														d-flex
														justify-center
													"
												>
													<v-icon
														size="30"
														class="pt-3"
														color="red darken-3"
													>
														mdi-close-circle-outline
													</v-icon>
												</div>
											</v-col>
											<v-divider vertical></v-divider>
											<v-col lg="2" xl="2" cols="6">
												<h2
													class="
														mt-n1
														font-weight-regular
														text-center
													"
												>
													Precio
												</h2>
												<h2
													class="
														mt-2
														font-weight-regular
														text-center
													"
												>
													{{
														selectedTariff
															? parseFloat(
																	(
																		selectedTariff.price *
																			iva +
																		(selectedTerminal &&
																		selectedTerminal.seguro &&
																		hasInsurance &&
																		arrayDescuentosAplicados.length ==
																			0
																			? selectedTerminal
																					.seguro
																					.price *
																			  iva
																			: 0)
																	).toFixed(2)
															  ).toLocaleString() +
															  '€'
															: ''
													}}
												</h2>
											</v-col>
										</v-row>

										<!-- Cabecera de las promociones -->
										<v-row
											v-if="selectedPromotion.length != 0"
											class="black--text"
										>
											<v-col
												v-if="
													!$vuetify.breakpoint
														.smAndDown
												"
												cols="3"
											>
											</v-col>
											<v-col
												:cols="
													$vuetify.breakpoint
														.smAndDown
														? '5'
														: '3'
												"
												:class="
													$vuetify.breakpoint
														.smAndDown
														? 'pa-2'
														: ''
												"
											>
												<h3
													class="font-weight-regular"
													:style="
														$vuetify.breakpoint
															.smAndDown
															? 'font-size: 0.87rem'
															: ''
													"
												>
													Promociones
												</h3>
											</v-col>
											<v-col
												cols="3"
												:class="
													$vuetify.breakpoint
														.smAndDown
														? 'pa-2'
														: ''
												"
											>
												<h3
													class="font-weight-regular"
													:style="
														$vuetify.breakpoint
															.smAndDown
															? 'font-size: 0.87rem'
															: ''
													"
												>
													Duración
												</h3>
											</v-col>
											<v-col
												:cols="
													$vuetify.breakpoint
														.smAndDown
														? '4'
														: '3'
												"
												:class="
													$vuetify.breakpoint
														.smAndDown
														? 'pa-2 '
														: ''
												"
											>
												<h3
													class="font-weight-regular"
													:style="
														$vuetify.breakpoint
															.smAndDown
															? 'font-size: 0.87rem'
															: ''
													"
												>
													Descuento
												</h3>
											</v-col>
											<v-divider vertical></v-divider>
											<v-col
												v-if="
													!$vuetify.breakpoint
														.smAndDown
												"
												cols="2"
											></v-col>
										</v-row>
										<v-row
											class="d-flex"
											v-for="(
												promotion, index
											) in selectedPromotion"
											:key="index"
										>
											<v-col
												v-if="
													!$vuetify.breakpoint
														.smAndDown
												"
												cols="3"
											>
											</v-col>
											<v-col
												:cols="
													$vuetify.breakpoint
														.smAndDown
														? '5'
														: '3'
												"
												class="d-flex align-center"
											>
												<v-tooltip
													left
													v-if="
														promotion.observations
													"
												>
													<template
														v-slot:activator="{
															on,
															attrs,
														}"
													>
														<v-btn
															v-if="
																!$vuetify
																	.breakpoint
																	.mdAndDown
															"
															icon
															color="primary"
															dark
															v-bind="attrs"
															v-on="on"
														>
															<v-icon
																color="primary"
															>
																mdi-magnify
															</v-icon>
														</v-btn>
													</template>
													<span>{{
														promotion.observations
													}}</span>
												</v-tooltip>
												<h4
													class="
														font-weight-regular
														black--text
													"
													:style="
														$vuetify.breakpoint
															.smAndDown
															? 'font-size: 0.87rem'
															: ''
													"
												>
													{{ promotion.name }}
												</h4>
											</v-col>
											<v-col cols="3">
												<h4
													class="
														font-weight-light
														black--text
													"
													:style="
														$vuetify.breakpoint
															.smAndDown
															? 'font-size: 0.87rem'
															: ''
													"
													:class="
														$vuetify.breakpoint
															.smAndDown
															? 'ma-0 pa-0'
															: ''
													"
												>
													{{
														promotion.duration
															? `${promotion.duration} Meses`
															: 'Para siempre'
													}}
												</h4>
											</v-col>
											<v-col
												:cols="
													$vuetify.breakpoint
														.smAndDown
														? '2'
														: '3'
												"
											>
												<h4
													class="
														font-weight-light
														black--text
														text-center
													"
													:style="
														$vuetify.breakpoint
															.smAndDown
															? 'font-size: 0.87rem'
															: ''
													"
												>
													{{
														selectedTariff
															? `${parseFloat(
																	promotion.amount *
																		(selectedTariff.segment ==
																			'NEGOCIOS' &&
																		promotion.amount_unit ==
																			'MONETARY'
																			? iva
																			: 1)
															  )} ${
																	promotion.amount_unit ==
																	'MONETARY'
																		? '€'
																		: '%'
															  }`
															: ''
													}}
												</h4>
											</v-col>
											<v-divider vertical></v-divider>
											<v-col
												xl="3"
												lg="3"
												md="3"
												cols="2"
												:class="
													$vuetify.breakpoint
														.smAndDown
														? 'd-flex justify-end mx-'
														: ''
												"
											>
												<h4
													class="
														font-weight-regular
														black--text
														text-center
													"
													:style="
														$vuetify.breakpoint
															.smAndDown
															? 'font-size: 0.87rem'
															: ''
													"
												>
													{{
														arrayDescuentosAplicados.length !=
														0
															? parseFloat(
																	arrayDescuentosAplicados[
																		index
																	].toFixed(2)
															  ).toLocaleString() +
															  '€'
															: ''
													}}
												</h4>
											</v-col>
										</v-row>
									</v-alert>
								</v-col>
							</v-row>
						</v-card>
					</v-stepper-content>
				</v-stepper-items>
			</v-stepper>
			<v-card-actions class="justify-end pb-3">
				<v-btn
					depressed
					color="primary"
					@click="currentStep++"
					v-if="currentStep < 4"
					:disabled="isDisabledContinuar"
					:loading="
						installmentsLoading ||
						(loadingTariffs && currentStep == 2)
					"
				>
					Continuar
				</v-btn>

				<v-btn v-else depressed color="primary" @click="submitPaquete">
					Guardar
				</v-btn>

				<v-btn
					text
					@click="currentStep--"
					:disabled="currentStep <= 1 ? true : false"
				>
					Atrás
				</v-btn>

				<v-btn
					text
					color="red darken-3"
					@click="closeConfiguratorStepper"
				>
					Cerrar
				</v-btn>
			</v-card-actions>
		</v-card>
		<InstallmentForm />
	</v-dialog>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import defaultPaqueteForm from '@/util/offerConfigurator/defaultPaqueteForm.js';
import { clone } from '@/util/libUtil.js';
import InstallmentForm from '@/components/ComercialTeletrabajo/DeviceManagement/InstallmentForm.vue';
import defaultInstallmentForm from '@/util/management/defaultInstallmentForm.js';

export default {
	name: 'offerStepper',
	components: {
		InstallmentForm,
	},
	data: () => ({
		arrayDescuentosAplicados: [],
		phoneNumberErrorMessages: [],
		uniqueInstallmentPayment: false,
		currentStep: 1,
		activeAdditionals: 0,
		categoryIcons: [
			'mdi-sim',
			'mdi-deskphone',
			'mdi-cellphone-nfc',
			'mdi-router-wireless-settings',
		],
		categories: [
			{
				name: 'Prepago',
				category: 'prepaid',
			},
			{
				name: 'Fijo',
				category: 'fixed_line',
			},
			{
				name: 'Pospago',
				category: 'mobile_line',
			},
			{
				name: 'Convergente',
				category: 'convergent',
			},
		],
		searchPhoneNumber: '', // Número de teléfono que estamos buscando entre los del cliente
		searchTariffs: '', // Tarifa que estamos buscando
		searchSellingUnits: '', // Unidad de venta que estamos buscando
		selectedCategoryStorage: null,
		searchTerminal: null, // Terminal que estamos buscando
		// isCrossSell: false,
		selectedPromotionId: '',
		tariffColors: [],
	}),
	methods: {
		getRandomColor() {
			var letters = '0123456789ABCDEF';
			var color = '#';
			for (var i = 0; i < 6; i++) {
				color += letters[Math.floor(Math.random() * 16)];
			}
			if (color == '#000000' || color == '#ffffff')
				return this.getRandomColor();
			return color;
		},
		mainLineIsEmpty() {
			return (
				JSON.stringify(this.mainLine) ==
				JSON.stringify({
					...defaultPaqueteForm,
					tipoLinea: 'LINEA_PRINCIPAL',
				})
			);
		},
		openAddingForm() {
			let installment_type = this.paquete.tipoVenta;

			if (
				this.paquete.tipoVenta == 'PORTA' ||
				this.paquete.tipoVenta == 'INTRAPORTABILIDAD'
			) {
				installment_type = 'PORTABILIDAD';
			}

			if (this.paquete.tipoVenta == 'MIGRACION') {
				installment_type = 'ALTA_NUEVA';
			}

			if (this.selectedCategory?.category == 'prepaid') {
				installment_type = 'PREPAGO';
			}

			let installmentObj = clone(defaultInstallmentForm);
			installmentObj['terminal__name'] = this.selectedTerminal.name;
			installmentObj['terminal__id'] = this.selectedTerminal.id;
			installmentObj['is_active'] = true;
			installmentObj['created_on'] = new Date().toISOString();
			installmentObj['updated_on'] = new Date().toISOString();
			installmentObj['installment_type'] = installment_type;
			installmentObj['object_id'] = this.selectedTariff.id;
			installmentObj['tariff_name'] = this.selectedTariff.name;

			this.$store.commit(
				'deviceManagement/editingInstallment',
				clone(installmentObj)
			);
			this.$store.commit(
				'deviceManagement/installmentFormType',
				'OFFER_CONFIGURATOR'
			);
			this.$store.commit(
				'deviceManagement/isOpenEditInstallmentDialog',
				true
			);
		},
		// getActiveInsurance(selectedTerminal) {
		//     if (selectedTerminal) {
		//         let seguros = selectedTerminal.seguros?.filter(
		//             (seguro) => seguro.is_active == true
		//         );
		//         return seguros ? seguros[0] : [];
		//     } else return [];
		// },
		filterInstallments() {
			return this.installments.filter(
				(item) => item.terminal == this.selectedTerminal?.id
			);
		},
		updateArrayPreciosPromo() {
			let precioDescuento = null;
			this.arrayDescuentosAplicados = [];
			if (this.selectedTariff) {
				this.selectedPromotion.forEach((promotion, index) => {
					precioDescuento =
						this.arrayDescuentosAplicados.length == 0
							? this.selectedTariff.price *
							  (this.selectedTariff.segment == 'PARTICULAR'
									? this.iva
									: 1)
							: this.arrayDescuentosAplicados[index - 1];
					if (promotion.amount_unit == 'MONETARY') {
						precioDescuento -= parseFloat(promotion.amount);
					} else if (promotion.amount_unit == 'PERCENTS') {
						precioDescuento *= 1 - promotion.amount * 0.01;
					}
					this.arrayDescuentosAplicados.push(precioDescuento);
				});
			}
			if (
				this.selectedTariff &&
				this.selectedTariff.segment == 'NEGOCIOS'
			) {
				this.arrayDescuentosAplicados =
					this.arrayDescuentosAplicados.map(
						(value) => value * this.iva
					);
			}
		},
		stepperPhoneNumberChanged(val) {
			let regexTelefono = /^(6|7|8|9)([0-9]){8}$/;
			let copy = [];
			let mainLinePhoneNumbers = [];
			mainLinePhoneNumbers =
				this.paquete.tipoLinea == 'LINEA_PRINCIPAL'
					? []
					: this.mainLine.lineasAsociadas;
			let additionalPhoneNumbers = [];

			// if (color == '#000000' || color == '#ffffff')
			return this.getRandomColor();

			// return color;
		},
		flipObj(obj) {
			// Intercambia las claves por el valor en un objeto
			return Object.fromEntries(
				Object.entries(obj).map((a) => a.reverse())
			);
		},
		closeConfiguratorStepper() {
			this.$store.commit(
				'configuradorOferta/isOpenConfiguratorStepper',
				false
			);
			// this.clearStepperFields();
		},
		// ESto hay que depurarlo alguna vez o comentarlo bien porque tremenda vaina
		submitPaquete() {
			if (this.hasInsurance)
				this.paquete.seguro = this.selectedTerminal.seguro;
			// this.getActiveInsurance(
			//     this.selectedTerminal
			// );

			console.log('submitPaquete', this.paquete);
			this.$store.commit('configuradorOferta/package');
			this.$store.commit(
				'configuradorOferta/isOpenConfiguratorStepper',
				false
			);

			this.$store.dispatch(
				'util/showStatusSnackBar',
				{
					statusType: 'success',
					message: 'Nuevo Paquete Añadido',
				},
				{
					root: true,
				}
			);
		},
		changeSelectedCategory(category) {
			this.selectedCategory = category;
		},
		changeSelectedTariff(tariff) {
			this.selectedTariff = tariff;
		},
		changeSelectedSellingUnit(sellType) {
			this.paquete.tipoVenta = this.opciones.paquete.tipoVenta.find(
				({ human }) => human == sellType
			).encoded;
		},
		clearStepperFields() {
			this.currentStep = 1;
			this.selectedPromotion = [];
			this.selectedCategoryStorage = null;
		},
		stripString(val) {
			if (typeof val !== 'string') return '';
			return val
				.toLowerCase()
				.normalize('NFD')
				.replace(/[\u0300-\u036f]/g, '')
				.replace(/\s/g, '');
		},
		badgeContent(tariff) {
			if (!tariff) return '';

			if (tariff.commercial_enrichment) {
				return tariff.commercial_enrichment
					? tariff.commercial_enrichment.sticker
						? tariff.commercial_enrichment.sticker.basket
						: ''
					: '';
			} else {
				return '';
			}
		},
	},
	computed: {
		createInstallment() {
			return (
				this.selectedOperator == 'DBL' &&
				this.paquete.tipoVenta == 'RENUEVO'
			);
		},
		filterTariffs() {
			let filters = {};
			let filteredTariffs = [];
			let additionals = [];

			if (this.$store.state.configuradorOferta.isp) {
				filters['segment'] =
					this.$store.state.configuradorOferta.isp.segment;
				filters['operator'] = this.selectedOperator;
			}

			if (
				this.selectedCategory &&
				this.selectedCategory.category != 'prepaid'
			) {
				filters['category'] = this.selectedCategory.category;
				filters['payment_type'] = 'postpaid';
			} else if (
				this.selectedCategory &&
				this.selectedCategory.category == 'prepaid'
			) {
				filters['payment_type'] = 'prepaid';
			}

			if (
				this.tariffs.length != 0 &&
				filters['category'] == 'mobile_line'
			) {
				let copyTariffs = clone(this.tariffs);
				additionals = clone(this.additionals);
				// copyTariffs.forEach((tariff) => {
				//     if (tariff.additional_lines.length > 0)
				//         tariff.additional_lines.forEach((additional) => {
				//             if (
				//                 additional.is_active == true &&
				//                 !additionals.find(
				//                     (element) => element.id == additional.id
				//                 )
				//             )
				//                 additionals.push(additional);
				//         });
				// });
			}

			let filterDict = (tariff) => {
				let value = true;
				Object.keys(filters).forEach((key) => {
					if (tariff[key] != filters[key]) {
						value = false;
					}
				});
				return value;
			};

			this.tariffs.forEach((tariff) => {
				if (filterDict(tariff)) filteredTariffs.push(tariff);
			});
			if (filters['category'] == 'mobile_line') {
				this.activeAdditionals = additionals.length;
				return [...additionals, ...filteredTariffs].filter((tariff) =>
					this.stripString(tariff.name).includes(
						this.stripString(this.searchTariffs)
					)
				);
			} else {
				this.activeAdditionals = 0;
				return filteredTariffs.filter((tariff) =>
					this.stripString(tariff.name).includes(
						this.stripString(this.searchTariffs)
					)
				);
			}
		},
		isOpenConfiguratorStepper: {
			get() {
				return this.$store.state.configuradorOferta
					.isOpenConfiguratorStepper;
			},
			set(val) {
				this.$store.commit(
					'configuradorOferta/isOpenConfiguratorStepper',
					val
				);
			},
		},
		availableTariffs() {
			let additionals = [];
			console.log(this.additionals);
			if (this.tariffs.length != 0) {
				let copyTariffs = clone(this.tariffs);
				additionals = clone(this.additionals);
				// copyTariffs.forEach((tariff) => {
				//     if (tariff.additional_lines.length > 0)
				//         tariff.additional_lines.forEach((additional) => {
				//             if (
				//                 additional.is_active == true &&
				//                 !additionals.find(
				//                     (element) => element.id == additional.id
				//                 )
				//             )
				//                 additionals.push(additional);
				//         });
				// });

				let all = [
					...additionals,
					...this.tariffs.filter(
						({ name }) =>
							!additionals.some(({ name2 }) => name2 == name)
					),
				];

				// Quitamos las que no sean tarifas de móvil

				return all.filter(
					(tariff) =>
						!tariff.category ||
						(tariff.category == 'mobile_line' &&
							tariff.payment_type == 'postpaid')
				);
			}

			let tariffs = [
				...additionals,
				...this.tariffs.filter(
					({ name }) =>
						!additionals.some(({ name2 }) => name2 == name)
				),
			];

			return tariffs ? this.filterTariffs(tariffs) : [];
		},
		availableSellTypes() {
			// Unidades de venta que estamos buscando en uno de los steps
			// is group is avatel remove renuevo and intraportabilidad
			let types = this.sellTypeNames.filter((unit) =>
				unit
					.toLowerCase()
					.includes(this.searchSellingUnits.toLowerCase())
			);

			if (this.ckeckGroupPermission([this.GROUPS.AVATEL])) {
				types = types.filter(
					(unit) => unit != 'Renuevo' && unit != 'Intraportabilidad'
				);
			}

			return types;
		},
		availablePromotions() {
			if (this.selectedTariff?.promotions) {
				let promos = [];
				this.selectedTariff.promotions.forEach((promo) => {
					let found = this.promotions.find(
						(element) => element.id == promo
					);
					if (found?.is_active == true) promos.push(found);
				});

				return promos;
			} else {
				return [];
			}
		},
		availableTelefonosContacto() {
			let usedTelefonos = this.paquetes.reduce(
				(acc, { lineasAsociadas }) => acc.concat(lineasAsociadas),
				[]
			);
			return this.cliente
				? this.cliente.telefonosContacto.filter(
						(tel) => !usedTelefonos.includes(tel)
				  )
				: [];
		},
		isDisabledContinuar() {
			return (
				!this.selectedCategory ||
				(this.currentStep >= 2 && !this.paquete.tipoVenta) ||
				(this.currentStep >= 3 &&
					(!this.selectedTariff || this.installmentsLoading)) ||
				(this.loadingTariffs && this.currentStep == 2)
			);
		},
		selectedTerminalInstallment() {
			let installment = this.filterInstallments();

			return this.installments && this.selectedTerminal
				? installment[Number(this.uniqueInstallmentPayment)]
				: null;
		},
		hasInsurance: {
			get() {
				return this.paquete.seguro;
			},
			set(val) {
				this.paquete.seguro = val;
			},
		},
		selectedPromotion: {
			get() {
				return this.paquete.promotion;
			},
			set(promoIds) {
				let promos = [];
				promoIds.forEach((promo) =>
					promos.push(
						this.availablePromotions.find(
							(promotion) => promo == promotion.id
						)
					)
				);

				this.paquete.promotion = promos;
			},
		},
		selectedTerminal: {
			get() {
				return this.paquete.cacharro;
			},
			set(terminal) {
				this.paquete.cacharro = terminal;
			},
		},
		selectedPhoneNumbers: {
			get() {
				return this.paquete.lineasAsociadas;
			},
			set(val) {
				this.paquete.lineasAsociadas = clone(val);
			},
		},
		selectedTariff: {
			get() {
				return this.paquete.tarifa;
			},
			set(val) {
				let installment_type = this.paquete.tipoVenta;

				if (
					this.paquete.tipoVenta == 'PORTA' ||
					this.paquete.tipoVenta == 'INTRAPORTABILIDAD'
				) {
					installment_type = 'PORTABILIDAD';
				}

				if (this.paquete.tipoVenta == 'MIGRACION') {
					installment_type = 'ALTA_NUEVA';
				}

				if (this.selectedCategory?.category == 'prepaid') {
					installment_type = 'PREPAGO';
				}

				this.$store.dispatch('configuradorOferta/getInstallments', {
					installment_type: installment_type,
					tarifa: val,
				});
				this.paquete.tarifa = val;
			},
		},
		selectedCategory: {
			get() {
				if (this.paquete.tarifa && this.paquete.tarifa.payment_type) {
					if (this.paquete.tarifa.payment_type == 'prepaid') {
						return this.categories.find(
							({ category }) => category == 'prepaid'
						);
					} else {
						return this.categories.find(
							({ category }) =>
								category == this.paquete.tarifa.category
						);
					}
				} else {
					return this.selectedCategoryStorage;
				}
			},
			set(val) {
				this.selectedCategoryStorage = val;
				this.paquete.tarifa = null;
			},
		},
		stepperType() {
			return this.$store.state.configuradorOferta.stepperType;
		},
		sellTypeEncode() {
			return this.flipObj(this.opciones.paquete.tipoVenta);
		},
		opciones() {
			return JSON.parse(localStorage.getItem('opciones'));
		},
		sellTypeNames() {
			return this.opciones
				? this.opciones.paquete.tipoVenta.map(({ human }) => human)
				: [];
		},
		...mapGetters('configuradorOferta', [
			'iva',
			'mainLine',
			'additionalPackages',
		]),
		...mapState('configuradorOferta', {
			selectedOperator: (state) => state.isp?.isp,
			loadingTariffs: (state) => state.loadingTariffs,
			tariffs: (state) => state.tariffs,
			additionals: (state) => state.additionals,
			operador: (state) => state.operador,
			terminals: (state) => state.terminals,
			promotions: (state) => state.promotions,
			installments: (state) => state.installments,
			installmentsLoading: (state) => state.installmentsLoading,
			// options_paquete: state => state.options.paquete,
			atencion: (state) => state.atencion,
			paquete: (state) => state.paquete,
			paquetes: (state) => state.atencion.oferta.paquetes,
			cliente: (state) => state.cliente,
		}),
		// ...mapState('util', {
		//     // opciones: (state) => state.opciones,
		//     sellTypeNames: (state) =>
		//         state.opciones
		//             ? state.opciones.paquete.tipoVenta.map(({ human }) => human)
		//             : [],
		// }),
		...mapState('general', {
			GROUPS: (state) => state.GROUPS,
		}),
		...mapGetters('login', {
			ckeckGroupPermission: 'ckeckGroupPermission',
		}),
	},
	watch: {
		hasInsurance: {
			immediate: true,
			handler() {
				this.updateArrayPreciosPromo();
				if (
					this.arrayDescuentosAplicados.length > 0 &&
					this.hasInsurance
				) {
					this.arrayDescuentosAplicados[
						this.arrayDescuentosAplicados.length - 1
					] += this.selectedTerminal?.seguro?.price * this.iva;
					// this.selectedTerminal &&
					// this.getActiveInsurance(selectedTerminal)
					//     ? this.getActiveInsurance(selectedTerminal).price *
					//       this.iva
					//     : 0;
				}
			},
		},
		selectedPromotion: {
			immediate: true,
			handler() {
				this.updateArrayPreciosPromo();
			},
		},
		currentStep() {
			if (this.currentStep == 3) {
				this.filterTariffs.forEach((element) => {
					this.tariffColors[this.filterTariffs.indexOf(element)] =
						this.getRandomColor();
				});
			}
		},
		model(val) {
			if (val && val.length > 5) {
				this.$nextTick(() => this.model.pop());
			}
		},

		isOpenConfiguratorStepper() {
			this.clearStepperFields();
			this.categoryIcons = [
				'mdi-sim',
				'mdi-deskphone',
				'mdi-cellphone-nfc',
				'mdi-router-wireless-settings',
			];
			this.categories = [
				{
					name: 'Prepago',
					category: 'prepaid',
				},
				{
					name: 'Fijo',
					category: 'fixed_line',
				},
				{
					name: 'Pospago',
					category: 'mobile_line',
				},
				{
					name: 'Convergente',
					category: 'convergent',
				},
			];
		},
	},
	created() {},
};
</script>

<style>
.topFixedHeigth {
	height: 125px !important;
}

.fixedHeigth {
	height: 124px !important;
}

.align-button {
	padding-top: 23px;
}

.aligned {
	align-self: center;
	text-align: center;
}

a {
	text-decoration: none;
}
</style>